import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./Navigation.module.css";
import useButtonLoading from "@hooks/useButtonLoading";
var Navigation = function Navigation(_ref) {
  var handleSubmit = _ref.handleSubmit,
    error = _ref.error,
    isLastQuestion = _ref.isLastQuestion;
  var _useTranslation = useTranslation(["web_survey"]),
    t = _useTranslation.t;
  var buttonLoading = useButtonLoading();
  return /*#__PURE__*/React.createElement("div", {
    className: stl.navWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.btnsWrapper
  }, /*#__PURE__*/React.createElement("button", {
    className: "".concat(stl.next, " ").concat(error ? stl.disabled : "", " ").concat(isLastQuestion ? stl.customSubmit : ""),
    onClick: handleSubmit,
    disabled: buttonLoading
  }, buttonLoading ? /*#__PURE__*/React.createElement("span", {
    className: stl.loader
  }) : isLastQuestion ? t("send", {
    ns: "web_survey"
  }) : t("next", {
    ns: "web_survey"
  }))));
};
export default Navigation;